export const NEW_FILTER_FIELD_CHANGE = 'NEW_FILTER_FIELD_CHANGE';
export const OPEN_NEW_FILTER_DIALOG = 'OPEN_NEW_FILTER_DIALOG';
export const CLOSE_NEW_FILTER_DIALOG = 'CLOSE_NEW_FILTER_DIALOG';
export const ADD_NEW_FILTER = 'ADD_NEW_FILTER';
export const NEW_FILTER_ADDED = 'NEW_FILTER_ADDED';
export const RESET_FILTER_DATA = 'RESET_FILTER_DATA';
